import * as Noty from "noty";
import {DOM} from "./DOM";
import {MessageItem} from "../definitions/utils/notify/MessageItem";
import {ControlsGeneralReportFeedbackControl} from "../../../app/controls/General/ReportFeedbackControl/ReportFeedbackControl";
import {Modal} from "./Modal";
import {Toggles} from "./Toggles";

// noinspection JSUnusedGlobalSymbols
Noty.overrideDefaults({
    callbacks: {
        afterShow: function() {
            const button = DOM.Parser.getHtmlElement(this.id).querySelector('button');
            if (button === null) { return; }
            DOM.Parser.getHtmlElementByClass('btn', DOM.Parser.getHtmlElement(this.id))
                .addEventListener('click', () => {
                    const eventId = DOM.Parser.getDataByNameFromElementOrNull('event', button);
                    ControlsGeneralReportFeedbackControl.Control.doShowModal(true, eventId);
                });
        },
        onTemplate: function() {

            const trsElem = DOM.Parser.getHtmlElement('jsTranslations');
            const codeTrs = DOM.Parser.getDataByNameFromElement('trsNotifyCode', trsElem);
            const eventTrs = DOM.Parser.getDataByNameFromElement('trsNotifyEvent', trsElem);
            const reportTrs = DOM.Parser.getDataByNameFromElement('trsNotifyReport', trsElem);
            const suffix = this.options.message.type.charAt(0).toUpperCase() + this.options.message.type.slice(1);
            const title = trsElem ? trsElem.dataset['trsNotify' + suffix] : null;

            const eventElem = this.options.message.eventId ?
                `<div class="noty-body-event">
                    ${eventTrs}: ${this.options.message.eventId}
                </div>` : '';

            const codeElem = this.options.message.uniqKeys && this.options.message.uniqKeys.length > 0 ?
                `<div class="noty-body-code">
                    ${codeTrs}: ${this.options.message.uniqKeys.join('_')}
                </div>` : '';

            const messageElem = this.options.message.message !== null ?
                `<div class="noty-body-text">
                    ${this.options.message.message}
                </div>` : '';

            const reportElemDisabled =  !Toggles.Handler.toggleAvailable('SENTRY');
            const reportElem = this.options.message.type === 'error' ?
                `<div class="noty-body-report">
                    <button ${reportElemDisabled ? 'disabled' : ''} class="btn btn-blue btn-minimal" data-event="${this.options.message.eventId ?? ''}">${reportTrs}</button>
                </div>` : '';


            this.barDom.innerHTML = `
                <div class="noty ${this.options.message.type}">
                    <div class="noty-body">
                        <div class="noty-body-title">
                            <div class="noty-body-title-icon">
                                <img src="/resources/images/2023/notify/${this.options.message.type}.svg" alt="${this.options.message.type}" />
                            </div>
                            <div class="noty-body-title-text">${title}</div>
                        </div>
                        ${messageElem}
                        ${codeElem}
                        ${eventElem}
                        ${reportElem}
                    </div>
                    <div class="noty_progressbar" style="transition: width 10000ms linear 0s; width: 100%;"></div>
                </div>
            `;
        }
    }
})

export module Notify {

    export class Handler {

        public static processMessagesFromDOM() : void {

            const domElem = DOM.Parser.getDataByNameFromElementOrNull('notify', DOM.Parser.getHtmlElementByQuery('body'));
            if (!domElem || domElem.trim().length === 0) { return; }
            const notifyMessages = JSON.parse(domElem);
            this.processMessages(notifyMessages);
        }

        /**
         * Process messages into notifications
         * When closing modal don't pass notifications to it
         * @param messageItems - list of messages
         * @param muteSuccess - success message mute
         * @param modalCloseByNotify - modal closed by notification
         */
        public static processMessages(messageItems: MessageItem[], muteSuccess: boolean = false, modalCloseByNotify: boolean = false): void {

            let container: undefined|string = undefined;
            const shownModal = Modal.Helpers.getShownModal();
            if (shownModal !== null && !modalCloseByNotify) {
                const errorElem = DOM.Parser.getHtmlElementByClass('customDesign-modals-content-error', shownModal);
                container = '.' + DOM.Parser.getDataByNameFromElement('selector', errorElem);
            }

            Noty.setMaxVisible(3, 'global');
            Noty.setMaxVisible(1, 'modal');

            for (let i = 0; i < messageItems.length; i++) {
                const message = messageItems[i];
                if (message.type === "success" && muteSuccess) { return; }
                new Noty({
                    // @ts-ignore
                    message: message,
                    layout: "bottomRight",
                    progressBar: true,
                    timeout: message.type === "success" ? 6000 : 12000,
                    queue: container ? 'modal' : 'global',
                    animation: {
                        open: container ? null : 'noty_effects_open',
                        close: container ? null : 'noty_effects_close'
                    },
                    container: container

                }).show();
            }
        }

        /**
         * Check is error is handler with notification
         * @param messageItems - list of messages
         */
        public static isErrorByNotify(messageItems: MessageItem[]): boolean {

            for (let i = 0; i < messageItems.length; i++) {
                if (messageItems[i].type === "error") { return true; }
            }

            return false;
        }

        /**
         * Check is closing modal with notification
         * @param messageItems - list of messages
         */
        public static isModalCloseByNotify(messageItems: MessageItem[]): boolean {

            for (let i = 0; i < messageItems.length; i++) {
                if (messageItems[i].closeModal) { return true; }
            }

            return false;
        }

        /**
         * Internal server error handler
         * Show just message about exception on FE
         */
        public static showServerError(eventId: string|null, uniqKeys?: string[]|null): void {

            this.processMessages([{
                message: document.getElementById('jsTranslations')?.dataset['trsNotifyFatalError'] ?? null,
                type: "error",
                closeModal: null,
                uniqKeys: uniqKeys ? uniqKeys : null,
                eventId: eventId
            }]);
        }

        public static getMessageFromPayload(payload: any): MessageItem|null {

            let response : any;
            if (payload.response) response = JSON.parse(payload.response);
            else response = payload;
            // noinspection JSUnresolvedReference
            if (!response.flashMessages) return null;
            // noinspection JSUnresolvedReference
            return response.flashMessages[0] ?? null;
        }
    }
}
